import { useSoyuzData } from '@spotahome/soyuz/client';
import {
  ThemeProvider,
  CookiesProvider,
  ToastContainer,
  UserInfoProvider,
  GoogleOneTap,
  AppBanner
} from '@spotahome/ui-library';

// Styles
import '@spotahome/landings-common/src/scss/init.scss';

import LazyLoginSignUpModal from '@spotahome/landings-common/src/components/LoginSignupModal';
import { getInstitutionsData } from '@spotahome/landings-common/src/api/real-estate-client';

import InstitutionsList from './components/InstitutionsList';

const InstitutionsListContainer = () => {
  const { [InstitutionsListContainer.NAME]: requestedData } = useSoyuzData();
  const { institutions, deviceType, initialCookie, userId } = requestedData;

  return (
    <CookiesProvider initialCookie={initialCookie}>
      <ThemeProvider flags={{ newButtons: true }}>
        <UserInfoProvider>
          <ToastContainer />
          <AppBanner source="home" deviceType={deviceType} />
          {!userId && <GoogleOneTap />}
          <InstitutionsList institutions={institutions} />
          <LazyLoginSignUpModal />
        </UserInfoProvider>
      </ThemeProvider>
    </CookiesProvider>
  );
};

InstitutionsListContainer.NAME = 'InstitutionsListContainer';

InstitutionsListContainer.requestData = async (req, domain = '') => {
  const response = await getInstitutionsData(domain);

  return {
    data: {
      institutions: response.data,
      deviceType: req.device.type,
      initialCookie: req.headers.cookie,
      userId: req.userId
    }
  };
};

InstitutionsListContainer.requestHeaders = () => {
  return {
    metas: [
      {
        name: 'robots',
        content: 'noindex'
      }
    ]
  };
};

export default InstitutionsListContainer;
